import { createFeatureSelector } from '@ngrx/store';
import { createApiCallSelectors } from '../../../../common/store/generic.selectors';
import { WorkScheduleModel, workScheduleFeatureKey } from './types';
import { IWorkScheduleState } from './work-schedule.reducer';

const workScheduleFeatureState = createFeatureSelector<IWorkScheduleState>(
  workScheduleFeatureKey,
);

export const workScheduleSelectors = {
  getById: createApiCallSelectors<WorkScheduleModel, IWorkScheduleState>(
    workScheduleFeatureState,
    'getById',
  ),
  createInstance: createApiCallSelectors<WorkScheduleModel, IWorkScheduleState>(
    workScheduleFeatureState,
    'createInstance',
  ),
  add: createApiCallSelectors<WorkScheduleModel, IWorkScheduleState>(
    workScheduleFeatureState,
    'add',
  ),
  update: createApiCallSelectors<WorkScheduleModel, IWorkScheduleState>(
    workScheduleFeatureState,
    'update',
  ),
  delete: createApiCallSelectors<boolean, IWorkScheduleState>(
    workScheduleFeatureState,
    'delete',
  ),
};
